import { render, staticRenderFns } from "./BlockOrder.vue?vue&type=template&id=264fecb5&scoped=true&name=block-order&"
import script from "./BlockOrder.vue?vue&type=script&lang=js&"
export * from "./BlockOrder.vue?vue&type=script&lang=js&"
import style0 from "./BlockOrder.vue?vue&type=style&index=0&id=264fecb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264fecb5",
  null
  
)

export default component.exports